app.config(function($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.otherwise("/start");

    $stateProvider
        .state('preview', {
            url: '/preview',
            templateUrl: 'views/preview.html',
            controller: 'previewController'
        })
        .state('signin', {
            url: '/signin',
            templateUrl: 'views/signin.html',
            controller: 'signinController'
        })
        .state('signout', {
            url: '/signout',
            controller: function($auth,$state){
                $auth.removeToken();
                $state.go('signin');
            }
        })
        .state('start', {
            url: '/start',
            templateUrl: 'views/start.html',
            controller: 'startController'
        })
        .state('preloader', {
            url: '/loading',
            templateUrl: 'views/preloader.html',
            controller: 'preloaderController',
        })
        .state('designchoices', {
            url: '/designchoices',
            templateUrl: 'views/designchoices.html',
            controller: 'designchoicesController',
        })
        .state('design', {
            url: '/design',
            templateUrl: 'views/design.html',
            controller: 'designController',
        })
        .state('help', {
            url: '/help',
            templateUrl: 'views/help.html',
            controller: 'helpController',
        })
        .state('checkout', {
            url: '/checkout',
            templateUrl: 'views/checkout.html',
            controller: 'checkoutController',
        })
        .state('tillvalslinje', {
            url: '/designlinje',
            templateUrl: 'views/tillvalslinje/tillvalslinjedesign.html',
            controller: 'tillvalscontroller',
        })
});
